import React from 'react'
import Journey from './views/Journey'

const App = (): JSX.Element => {
  return <Journey />
}

export default App
